import { render, staticRenderFns } from "./skillScore.vue?vue&type=template&id=39164009&scoped=true&"
import script from "./skillScore.vue?vue&type=script&lang=js&"
export * from "./skillScore.vue?vue&type=script&lang=js&"
import style0 from "./skillScore.vue?vue&type=style&index=0&id=39164009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39164009",
  null
  
)

export default component.exports